export default "__VITE_ASSET__FyJfbDcX__"